export default "__VITE_ASSET__dP0DBilI__";